import React from "react";
import referenceFeatureMarkup from "./ReferenceFeatureMarkup";
import referenceFeatureAnimations from "./ReferenceFeatureAnimations";
import "./ReferenceFeatureShowcase.css";

export default function ReferenceFeatureShowcase() {
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: referenceFeatureAnimations }} />
      <section id="features" className="reference-features reference-features-exact" dangerouslySetInnerHTML={{ __html: referenceFeatureMarkup }} />
    </>
  );
}
